import type { View } from "@-/com.npmjs.react-native";
import Animated, { useAnimatedRef } from "@-/com.npmjs.react-native-reanimated";
import { useContext, useEffect, type ReactNode } from "react";
import { LearnFlashcardHorizontalGestureBlockersContext } from "#learn-card-horizontal-gesture-blockers-context";

/**
 * Touches that START inside `children` never drag the Learn card, so they never reveal or rate it.
 *
 * The card pan activates after 4pt of horizontal travel, and a front's drag-start reveals it. A tap
 * on an in-card control (e.g. the pinyin keyboard: its keys, the gaps between them and its edge
 * insets) routinely drifts that far, so it would reveal the card instead of typing. The card pan
 * measures this view on touch-down (on the UI thread) and fails when the touch starts inside it.
 * Nothing here handles touches, so the controls' own presses are untouched.
 */
export function LearnFlashcardHorizontalGestureBlocker({ children }: { children: ReactNode }) {
  const registerBlocker = useContext(LearnFlashcardHorizontalGestureBlockersContext);
  const view = useAnimatedRef<View>();
  useEffect(() => registerBlocker?.(view), [registerBlocker, view]);
  return (
    <Animated.View collapsable={false} ref={view}>
      {children}
    </Animated.View>
  );
}
